export enum AttemptState {
  Processing = 'Processing',
  Normally = 'Normally',
  HangUp = 'HangUp',
  NoAnswer = 'NoAnswer',
  BotDetected = 'BotDetected',
  Error = 'Error',
}

export const AttemptStateOptions: { value: string; text: string }[] = [
  { value: AttemptState.Normally, text: 'Разговор завершен штатно' },
  { value: AttemptState.HangUp, text: 'Абонент завершил звонок' },
  { value: AttemptState.NoAnswer, text: 'Нет ответа' },
  { value: AttemptState.BotDetected, text: 'Автоответчик' },
  { value: AttemptState.Error, text: 'Ошибка' },
];

const ATTEMPT_STATE_TEXT_MAP: Record<string, string> = {
  [AttemptState.Processing]: 'В обработке',
  [AttemptState.Normally]: 'Разговор завершен штатно',
  [AttemptState.HangUp]: 'Абонент завершил звонок',
  [AttemptState.NoAnswer]: 'Нет ответа',
  [AttemptState.BotDetected]: 'Автоответчик',
  [AttemptState.Error]: 'Ошибка',
  normally: 'Разговор завершен штатно',
  hang_up: 'Абонент завершил звонок',
  no_answer: 'Нет ответа',
  bot_detected: 'Автоответчик',
  error: 'Ошибка',
};

export const attemptStateDescription = (value: string | number): string => {
  if (typeof value === 'number') {
    return `${value}`;
  }
  return ATTEMPT_STATE_TEXT_MAP[value] ?? value ?? 'Неизвестно';
};
